<template>
    <v-flex>
      <v-card>
        <gmap-map
           style="width:100%; height: 40vh;"
           :center="center"
           :zoom="8"
           :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: true,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false
            }">
        <gmap-marker
            v-for="(m, i) in markers"
            :key="i"
            :position="m.position"
            :clickable="true"
            :draggable="false">
        </gmap-marker>
    </gmap-map>
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">phone</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ customer.phone }}</v-list-tile-title>
              <v-list-tile-sub-title>Telefon</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action></v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ customer.mobile }}</v-list-tile-title>
              <v-list-tile-sub-title>Mobil</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile @click="triggerMail()">
            <v-list-tile-action>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ customer.email }}</v-list-tile-title>
              <v-list-tile-sub-title>E-Mail</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action></v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ customer.name }}</v-list-tile-title>
              <v-list-tile-sub-title>Name</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">location_on</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ customer.street }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ customer.zip }} {{ customer.city }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
export default {
  computed: {
    google: gmapApi
  },
  props: {
    customer: {}
  },
  data() {
    return {
      center: { lat: 50.1109221, lng: 8.6821267 },
      markers: [
        {
          position: { lat: 50.1109221, lng: 8.6821267 }
        }
      ]
    };
  },
  watch: {
    customer() {
      console.log(this.customer);
      let located = {
        lat: this.customer.latitude,
        lng: this.customer.longitude
      };
      this.center = located;
      this.markers = [{ position: located }];
    }
  },
  methods: {
    triggerMail() {
      const mailstring = 'mailto:' + this.customer.email;
      window.location.href = mailstring;
    },
    tableClicked(customer) {
      console.log(customer);
    }
  }
};
</script>
